import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { StorageService } from '../storage-service/storage.service';
import { StorageKeys } from '../../enums/storage.enum';

@Injectable({
  providedIn: 'root',
})
export class CompanyServiceService {
  constructor(
    private readonly http: HttpClient,
    private readonly storageService: StorageService
  ) {}

  getToCompanyList(options?: { refresh?: boolean }) {
    if (!options?.refresh) {
      const cachedCompanies = this.storageService.getDataFromSessionStorage(StorageKeys.COMPANY_LIST);
      if (cachedCompanies) {
        return of(cachedCompanies);
      }
    }
    let url = environment.BASE_URL + '/v1/company';
    return this.http.get(url).pipe(
      tap((response: any) => {
        this.storageService.setDataToSessionStorage(StorageKeys.COMPANY_LIST, response);
      })
    );
  }

  getAllCompanyList1(filterName :any) {
    let url = environment.BASE_URL + '/v1/company';
    return this.http.get(url, { params: filterName });
  }

  activateCompany(companyId: any, data: any) {
    let url = environment.BASE_URL + '/v1/company/' + companyId + '/' + data;
    return this.http.put(url, {});
  }
  getAllCompanyList(name: string) {
    let params = new HttpParams();
    params = params.append('name', name);
    params = params.append('skip', 1);
    params = params.append('limit', 100);
    let url = environment.BASE_URL + '/v1/company';
    return this.http.get(url, { params: params });
  }
  createRootCompany(payload: any) {
    let url = environment.BASE_URL + '/v1/company/root-company';
    return this.http.post(url, payload);
  }
  createSubCompany(payload: any) {
    let url = environment.BASE_URL + '/v1/company/sub-company';
    return this.http.post(url, payload);
  }
  getCompanyDataById(companyId: any) {
    let url = environment.BASE_URL + `/v1/company/${companyId}`;
    return this.http.get(url);
  }

  getAllTemplateDetails() {
    let url = environment.BASE_URL + '/v1/lr-templates';
    return this.http.get(url);
  }

  getAllTemplatesByCompanyId(companyId: any) {
    let url =
      environment.BASE_URL + '/v1/company-lr-template/company/' + companyId;
    return this.http.get(url);
  }

  assignTemplateToCompany(payload: any) {
    let url = environment.BASE_URL + '/v1/company-lr-template';
    return this.http.post(url, payload);
  }
  createOrgStruct(payload: any) {
    let url =
      environment.BASE_URL + '/v1/company-structure/' + payload.rootCompany;
    return this.http.post(url, payload);
  }
  getOrganizationStructureById(id: any) {
    let url = environment.BASE_URL + '/v1/company-structure';
    if (id) {
      url += '/' + id;
    }
    return this.http.get(url);
  }
  editInvite(id: any, data: any) {
    let url = environment.BASE_URL + '/v1/contacts/edit/' + id;
    return this.http.put(url, data);
  }

  updateCompanyDetails(payload: any, companyId:any) {
    let url = environment.BASE_URL + '/v1/company/'+companyId;
    return this.http.put(url, payload);
  }

  updateCompany(payload: any): Observable<any>{
    let url = `${environment.BASE_URL}/v1/company/${payload.id}/sub-company`;
    return this.http.put(url,payload);
  }
  
}
